<template>
  <div class="component" :id="id">
                  
    <div class="row">
      <div class="password-policies-header pb-3"> 
          Password Rules:
      </div>                    
      <div class="pb-4">
        <ul class="ml-1">
          <li class="password-policy" v-if="passwordValidationComplexity.excludeUsername">
            <div class="password-policy-item" :class="{'success-policy': passwordValidPolicies.excludeUsername}">
              <div>
                Exclude Username: 
              </div>
              <div class="pl-3 pr-2"> {{passwordValidationComplexity.excludeUsername}} </div>
              <v-slide-x-reverse-transition>
                <v-icon v-if="passwordValidPolicies.excludeUsername" class="success-icon success-policy" left> 
                  mdi-check-circle 
                </v-icon>
              </v-slide-x-reverse-transition>
            </div>
          </li>
          <li class="password-policy" v-if="passwordValidationComplexity.minLength">
            <div class="password-policy-item" :class="{'success-policy': passwordValidPolicies.minLength}">
              <div> 
                Minimum Length: 
              </div>
              <div class="pl-3 pr-2"> {{ passwordValidationComplexity.minLength }} </div>
              <v-slide-x-reverse-transition>
                <v-icon v-if="passwordValidPolicies.minLength" class="success-icon success-policy" left> 
                  mdi-check-circle 
                </v-icon>
              </v-slide-x-reverse-transition>
            </div>
          </li>   
          <li class="password-policy" v-if="passwordValidationComplexity.minLowerCase">
            <div class="password-policy-item py-2" :class="{'success-policy': passwordValidPolicies.minLowerCase}">
              <div> 
                Minimum Lower Case Characters: 
              </div>
              <div class="pl-3 pr-2"> {{ passwordValidationComplexity.minLowerCase }} </div>
              <v-slide-x-reverse-transition>
                <v-icon v-if="passwordValidPolicies.minLowerCase" class="success-icon success-policy" left> 
                  mdi-check-circle 
                </v-icon>
              </v-slide-x-reverse-transition>
            </div>
          </li>
          <li class="password-policy" v-if="passwordValidationComplexity.minNumber">
            <div class="password-policy-item py-2" :class="{'success-policy': passwordValidPolicies.minNumber}">
              <div> 
                Minimum Number Characters: 
              </div>
              <div class="pl-3 pr-2"> {{ passwordValidationComplexity.minNumber }} </div>
              <v-slide-x-reverse-transition>
                <v-icon v-if="passwordValidPolicies.minNumber" class="success-icon success-policy" left> 
                  mdi-check-circle 
                </v-icon>
              </v-slide-x-reverse-transition>
            </div>
          </li>
          <li class="password-policy" v-if="passwordValidationComplexity.minSymbol">
            <div class="password-policy-item py-2" :class="{'success-policy': passwordValidPolicies.minSymbol}">
              <div> 
                Minimum Symbol Characters: 
              </div>
              <div class="pl-3 pr-2"> {{ passwordValidationComplexity.minSymbol }} </div>
              <v-slide-x-reverse-transition>
                <v-icon v-if="passwordValidPolicies.minSymbol" class="success-icon success-policy" left> 
                  mdi-check-circle 
                </v-icon>
              </v-slide-x-reverse-transition>
            </div>
          </li>
          <li class="password-policy" v-if="passwordValidationComplexity.minUpperCase">
            <div class="password-policy-item py-2" :class="{'success-policy': passwordValidPolicies.minUpperCase}">
              <div> 
                Minimum Upper Case Characters: 
              </div>
              <div class="pl-3 pr-2"> {{ passwordValidationComplexity.minUpperCase }} </div>
              <v-slide-x-reverse-transition>
                <v-icon v-if="passwordValidPolicies.minUpperCase" class="success-icon success-policy" left> 
                  mdi-check-circle 
                </v-icon>
              </v-slide-x-reverse-transition>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">

  import { VIcon, VSlideXReverseTransition } from 'vuetify/lib'

  import PasswordValidationMixin from '@/mixins/passwordValidation';
  import EventBusConstants from '@/constants/eventBus';

  import EventBus from '@/services/eventBus';

  export default {
    name: 'components-json_page-components-okta-password-policy',
    watch: {},
    props: {
        id: undefined
    },
    data() {
      return {}
    },
    methods: {
      setEventListeners() {
        EventBus.$on(EventBusConstants.OKTA_PASSWORD_POLICIES_STATUS, (value) => {
          this.passwordValidPolicies = value;
          this.$forceUpdate();
        });
      },
    },
    computed: {
    },
    created() {
      this.setEventListeners();
      this.passwordValidationRetrievePasswordSettings();
    },
    mounted() {},
    beforeDestroy() {},
    mixins: [
      PasswordValidationMixin
    ],
    components: {
        VIcon,
        VSlideXReverseTransition
    }
  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

  @import "../../../assets/variables";

  .password-policies-header {
    font-size: 16px;
    font-weight: 600;
  }

  .password-policy {
    align-items: center;
    width: fit-content;
  }

  .password-policy-item {
    display: flex;
    align-items: center;
    height: 35px;
  }

  .success-icon {
    font-size: 20px;
  }

  .success-policy {
    color: $colorSuccess !important; 
  }

</style>
